var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-4 -4 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00063 20.7084L4.74206 21.5657C5.84774 22.1101 7.32448 21.856 8.18487 20.9737L9.03087 20.1052L10.8799 22.9273C11.7547 24.2626 13.478 24.2545 14.344 22.9148L18.3925 16.6549L23.0293 24.583C23.9347 26.1323 25.8 25.9014 26.2806 24.165L30 10.721V25.454C30 28.4751 28.4751 30 25.4096 30H7.60544C4.55496 30 3 28.4895 3 25.454L3.00063 20.7084ZM3.00063 17.9013V7.54599C3.00063 4.51053 4.55496 3 7.60606 3H25.4096C27.1773 3 28.4331 3.50685 29.179 4.51616L28.3205 7.40583L24.3258 21.8429L20.1596 14.717C19.3387 13.314 17.5972 13.2759 16.7149 14.64L12.6057 20.9944L10.9563 18.4764C10.1391 17.2287 8.49586 17.0697 7.45463 18.1372L6.39276 19.226C6.28826 19.333 5.98102 19.3862 5.84836 19.3205L3.91233 18.3675L3.00063 17.9013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrading);
export default __webpack_public_path__ + "static/media/trading.ae95cebea8b51b02653b4ca8e7fb3a6b.svg";
export { ForwardRef as ReactComponent };